import _ from 'underscore';
import React, { useEffect, useState } from 'react';
import { matchStepState, useWizardService } from '@bingads-webui-react/wizard-core';
import { FORM_STATES } from '@bingads-webui-react/form-core';
import { PageReadyTrigger } from '@bingads-webui-campaign-react/page-ready-trigger';
import { PageReady } from '@bingads-webui/page-ready';

// Page ready timeout is set to 15 seconds to allow for the page to load
// and the wizard to initialize.
const PAGE_READY_TIMEOUT = 15000;

export const StepRenderPageReady = () => {
  const [isStepRendered, setIsAnyStepRendered] = useState(false);
  const { state } = useWizardService();

  useEffect(() => {
    _.delay(() => {
      PageReady.pageIsReady();
    }, PAGE_READY_TIMEOUT);
  }, []);

  useEffect(() => {
    if (!isStepRendered && matchStepState(state, FORM_STATES.ACTIVE)) {
      setTimeout(() => {
        setIsAnyStepRendered(true);
      }, 0);
    }
  }, [isStepRendered, state]);

  return isStepRendered ? <PageReadyTrigger /> : null;
};
